import React, { useEffect, useState } from 'react';
import { Button, Box, Heading, useToast, Select } from '@chakra-ui/react';
import { collection, getDocs, writeBatch, query, where } from 'firebase/firestore';
import { db } from '../../lib/firebase';
import { useAuth } from '../../context/AuthContext';

const ActivarQuinielas: React.FC = () => {
  const toast = useToast();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [phases, setPhases] = useState<string[]>([]);
  const [selectedPhase, setSelectedPhase] = useState('');

  // Cargar las fases/jornadas disponibles
  useEffect(() => {
    const fetchPhases = async () => {
      const matchesRef = collection(db, 'matches');
      const matchesSnap = await getDocs(matchesRef);
      const uniquePhases = Array.from(new Set(matchesSnap.docs.map(doc => doc.data().phase)));
      setPhases(uniquePhases);
    };
    fetchPhases();
  }, []);

  const handleActivateQuinielas = async () => {
    console.log('¡Entrando a handleActivateQuinielas!');
    if (!selectedPhase) {
      toast({
        title: 'Selecciona una jornada',
        status: 'warning',
        duration: 2000,
      });
      return;
    }
    setLoading(true);
    try {
      // 1. Obtener los partidos de la jornada seleccionada
      const matchesRef = collection(db, 'matches');
      const matchesSnap = await getDocs(query(matchesRef, where('phase', '==', selectedPhase)));
      const matchIds = matchesSnap.docs.map(doc => doc.id);

      console.log('Partidos de la jornada seleccionada:', matchIds);

      // 2. Obtener los pronósticos de esos partidos
      const predictionsRef = collection(db, 'predictions');
      const predictionsSnap = await getDocs(predictionsRef);

      const batch = writeBatch(db);
      let updatedCount = 0;

      predictionsSnap.docs.forEach(docSnap => {
        const prediction = docSnap.data();
        // Estructura 1: un documento por partido
        if (prediction.match_id && matchIds.includes(prediction.match_id)) {
          console.log('Activando predicción:', docSnap.id, prediction);
          batch.update(docSnap.ref, { activo: 1 });
          updatedCount++;
        }
        // Estructura 2: array de predicciones por usuario
        if (Array.isArray(prediction.predictions)) {
          let changed = false;
          const newPredictions = prediction.predictions.map((p: any) => {
            if (matchIds.includes(p.match_id)) {
              if (p.activo !== 1) {
                changed = true;
                console.log('Activando predicción anidada:', p);
                return { ...p, activo: 1 };
              }
            }
            return p;
          });
          if (changed) {
            batch.update(docSnap.ref, { predictions: newPredictions });
            updatedCount++;
          }
        }
      });

      await batch.commit();
      toast({
        title: 'Jornada activada',
        description: `Se activaron ${updatedCount} pronósticos de la jornada "${selectedPhase}".`,
        status: 'success',
        duration: 4000,
      });
    } catch (error) {
      console.error('Error al activar quinielas:', error);
      toast({
        title: 'Error',
        description: 'No se pudieron activar las quinielas.',
        status: 'error',
        duration: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  if (!user || user.email !== 'htorres@teiker.mx') {
    return (
      <Box p={4}>
        <Heading size="md">No tienes acceso a esta página</Heading>
      </Box>
    );
  }

  return (
    <Box p={8} textAlign="center">
      <Heading size="lg" mb={6}>Activar Quinielas por Jornada</Heading>
      <Select
        placeholder="Selecciona la jornada"
        value={selectedPhase}
        onChange={e => setSelectedPhase(e.target.value)}
        mb={4}
        maxW="400px"
        mx="auto"
      >
        {phases.map(phase => (
          <option key={phase} value={phase}>{phase}</option>
        ))}
      </Select>
      <Button
        colorScheme="green"
        size="lg"
        onClick={handleActivateQuinielas}
        isLoading={loading}
        isDisabled={!selectedPhase}
      >
        Activar Quinielas
      </Button>
    </Box>
  );
};

export default ActivarQuinielas; 